import TopLogoArea from "./TopLogoArea";

export default {
  TopLogoArea,
};
